import { HomeLayoutDS } from './home-layout.ds';
import { HomeLayoutEH } from './home-layout.eh';
import * as DS from '../../data-sources';
import * as EH from '../../event-handlers';
import { PersonaInfoDS } from 'src/app/data-sources/personal-info.ds';
import { JobsDS } from 'src/app/data-sources/jobs.ds';
import { RealEstatesDS } from 'src/app/data-sources/real-estates.ds';
import { RevenuesDS } from 'src/app/data-sources/revenues.ds';
import { ProfitDS } from 'src/app/data-sources/profit.ds';
import { EbitdaDS } from 'src/app/data-sources/ebitda.ds';
import { ChartItitleDS } from 'src/app/data-sources/chart-ititle.ds';
import { ChartDatawDS } from 'src/app/data-sources/chart-dataw.ds';
import { SharesDS } from 'src/app/data-sources/shares.ds';
import { ExportPdfDS } from '../../data-sources';
import { ExportPdfEH } from '../../event-handlers';
import { CentralityScoreDS } from 'src/app/data-sources/centrality-score.ds';
import { CgrP15DS } from 'src/app/data-sources/cgrp15.ds';
import { CgrP4DS } from 'src/app/data-sources/cgrp4.ds';

export const HomeLayoutConfig = {
  layoutId: 'dc-home-layout',
  widgets: [
    {
      id: 'dc-home'
    },
    {
      id: 'personal-info-metadata',
      dataSource: PersonaInfoDS
    },
    {
      id: 'jobs-table',
      dataSource: JobsDS
    },
    {
      id: 'main-shares-table',
      dataSource: SharesDS,
      options: {key: 'main'}
    },
    {
      id: 'other-shares-table',
      dataSource: SharesDS,
      options: {key: 'others'}
    },
    {
      id: 'real-estates-table',
      dataSource: RealEstatesDS
    },
    {
      id: 'revenues-chart',
      dataSource: RevenuesDS,
      options: { key: 'Ricavi' }
    },
    {
      id: 'profit-chart',
      dataSource: ProfitDS,
      options: { key: 'Utile'}
    },
    {
      id: 'ebitda-chart',
      dataSource: EbitdaDS,
      options: { key: 'EBITDA'}
    },
    {
      id: 'centrality-score-chart',
      dataSource: CentralityScoreDS,
    },
    {
      id: 'cgrp15-chart',
      dataSource: CgrP15DS,
    },
    {
      id: 'cgrp4-chart',
      dataSource: CgrP4DS,
    },
    {
      id: 'title'
    },
    {
      id: 'export-pdf',
    },
    {
      id: 'dc-nav'
    },
    {
      id: 'profit-ititle',
      dataSource: ChartItitleDS,
      options: { key: 'Utile'}
    },
    {
      id: 'revenues-ititle',
      dataSource: ChartItitleDS,
      options: { key: 'Ricavi' }
    },
    {
      id: 'ebitda-ititle',
      dataSource: ChartItitleDS,
      options: { key: 'EBITDA'}
    },
    {
      id: 'revenues-dataw',
      dataSource: ChartDatawDS,
      options: { key: 'Ricavi' }
    },
    {
      id: 'profit-dataw',
      dataSource: ChartDatawDS,
      options: { key: 'Utile' }
    },
    {
      id: 'ebitda-dataw',
      dataSource: ChartDatawDS,
      options: { key: 'ebitda' }
    }
  ],
  layoutDS: HomeLayoutDS,
  layoutEH: HomeLayoutEH,
  widgetsDataSources: DS,
  widgetsEventHandlers: EH,
  layoutOptions: {

  }
};
